<template>
  <div class="search-content">
    <div class="search-content-header">
      <v-select
        class="search-content-select"
        v-model="selectedSorting"
        :reduce="option => option.value"
        :options="sortingOptions"
        label="label"
        :selectable="option => option.selectable"
        :placeholder="sortingPlaceholder"
        :clearable="false"
        :searchable="false"
      >
      </v-select>
      <button @click="goToSite" class="btn-green" :style="{'background-color': shopColor}">{{ backBtnTitle }}
      </button>
    </div>
    <div class="shops-grid">
      <div v-for="item in sortedStores" :key="item.id">
        <a :href="item.url">
          <div class="wrapper-white">
            <div v-if="item.logo" class="wrapper-img d-flex justify-content-center align-items-center ">
              <img :src="item.logo"
                   :alt="item.name" class="">
            </div>
            <div v-else class="wrapper-img d-flex justify-content-center align-items-center ">
              <span>{{ item.name }}</span>
            </div>
            <div class="shop-name p-3">
                      <span class="status-job -sale"
                            :style="{backgroundColor: item.badge.color}"
                            v-if="item.badge">{{ item.badge.content }}</span>
              <h5 class="mt-3 mb-3">{{ item.name }}</h5>

              <span class="link-orange text-decoration-none text-center mb-2"
                    v-for="cat in item.categories"
                    :key="'spanItem'+item.id+'category'+cat"
                    v-if="categories[cat]">
                              {{ categories[cat].name }}<br :key="'separatorItem'+item.id+'category'+cat">
                          </span>
              <span v-if="item.working_hours"
                    class="link-orange text-decoration-none mt-2 text-center">
                              <strong class="font-bold">{{ tWorkingHours }}</strong>
                          </span>
              <span v-if="item.working_hours"
                    :key="'itemWorkingHoursKey'+key"
                    class="link-orange text-decoration-none mt-2 text-center"
                    v-for="(value, key) in item.working_hours">
                                  <span v-html="key"></span> <span v-html="value"></span>
                          </span>
            </div>
          </div>
        </a>
      </div>

      <div class="loader" v-if="showLoader||showFirstLoader">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
             preserveAspectRatio="xMidYMid" class="lds-double-ring">
          <circle cx="50" cy="50"
                  fill="none"
                  stroke-linecap="round"
                  r="40"
                  :stroke="strokeColor"
                  stroke-width="4"
                  stroke-dasharray="62.83185307179586 62.83185307179586"
                  transform="rotate(107.463 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                              values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                              repeatCount="indefinite"></animateTransform>
          </circle>
          <circle cx="50" cy="50"
                  :stroke="strokeColor"
                  fill="none"
                  stroke-linecap="round"
                  r="35"
                  stroke-width="4"
                  stroke-dasharray="54.97787143782138 54.97787143782138"
                  stroke-dashoffset="54.97787143782138"
                  transform="rotate(-107.463 50 50)">
            <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                              values="0 50 50;-360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                              repeatCount="indefinite"></animateTransform>
          </circle>
        </svg>
      </div>
    </div>

    <template v-if="sortedStores.length < 1 && !showFirstLoader">
      <h4 class="text-center w-100">{{ tNoData }}</h4>
    </template>

    <div v-if="!showFirstLoader && !showLoader && categoryIdFromUrl && selectedCategories.length === 1"
         class="category-description">
      <p>{{ getCategoryDescriptionList[selectedCategories[0]] }}</p>
    </div>
  </div>

</template>

<script>
// todo laoder na perwuju zagruzku
// todo laoder na sortirowku
// TODO COLOR FROM CONFIG
import {mapActions, mapGetters} from 'vuex'
import {
  BACK_BTN_LINK,
  SHOP_COLOR,
  T_NO_DATA,
  T_WORKING_HOURS,
  ORDER_BY_VALUES,
  T_ORDER_BY,
  T_BACK_BTN
} from '@/config/AppConfig'

export default {
  name: 'SearchContent',
  props: {
    categoryIdFromUrl: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      shopColor: SHOP_COLOR,
      strokeColor: SHOP_COLOR,
      tNoData: T_NO_DATA,
      hiddenCnt: 0,
      showLoader: false,
      showFirstLoader: true,
      tWorkingHours: T_WORKING_HOURS,
      checkHiddenValue: false,
      selectedSorting: '',
      sortingOptions: [
        {label: ORDER_BY_VALUES.sortBy, value: null, selectable: false},
        {label: ORDER_BY_VALUES.default, value: 1, selectable: true},
        {label: ORDER_BY_VALUES.titleAsc, value: 2, selectable: true},
        {label: ORDER_BY_VALUES.titleDesc, value: 3, selectable: true},
        {label: ORDER_BY_VALUES.promotion, value: 4, selectable: true},
      ],
      sortingPlaceholder: T_ORDER_BY,
      backBtnTitle: T_BACK_BTN
    }
  },
  computed: {
    ...mapGetters(['getFilteredStores', 'getCategoryDescriptionList', 'getSearchQuery']),
    categories() {
      return this.$store.getters.getStoreVar('categories')
    },
    selectedCategories() {
      return this.$store.getters.getStoreVar('selectedCategories')
    },
    sortedStores() {
      let array = [...this.$store.getters['getFilteredStores']]

      switch (this.selectedSorting) {
        case 1:
          break
        case 2:
          array = array.sort((a, b) => a.name.localeCompare(b.name))
          break
        case 3:
          array = array.sort((a, b) => -(a.name.localeCompare(b.name)))
          break
        case 4:
          let [specialOffer, normalOffer] = this.partition(array, e => e.badge && e.badge.type === 'special-offer')
          normalOffer.sort((a, b) => a.name.localeCompare(b.name))
          array = specialOffer.concat(normalOffer)
          break
        default:
          break
      }

      if (this.str.length > 0) {
        array = array.filter(shop => shop.name.toLowerCase().includes(this.str.toLowerCase()))
      }

      return array
    },
    orderBy() {
      return this.$store.getters.getStoreVar('orderBy')
    },
    str() {
      return this.$store.getters.getStoreVar('str')
    },
    checkHidden: {
      get() {
        return this.checkHiddenValue
      },
      set(val) {
        this.checkHiddenValue = val
      }
    }
  },
  methods: {
    ...mapActions(['getItems', 'setStoreVar']),
    hideLoader() {
      setTimeout(() => {
        this.showLoader = false
      }, 300)
    },
    partition(array, filter) {
      let pass = [], fail = [];
      array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
      return [pass, fail];
    },
    goToSite() {
      window.location.href = BACK_BTN_LINK
    }
  },
  created() {
    this.getItems()
      .then(() => {
        this.showFirstLoader = false
      })
  },
}
</script>

<style scoped>
.text-decoration-none {
  text-decoration: none !important;
}

strong {
  font-family: "Montserrat-Medium";
}

.loader {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .6);
  text-align: center;
  padding-top: 60px;
}

.loader svg {
  vertical-align: baseline;
  width: 100px;
  height: 100px;
  margin: auto;
}

.search-content-header .vs__actions .vs__open-indicator {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchContent.vue